import styled from 'styled-components';

export const MyPageInner = styled.div`
    height: 100%;
    overflow-y: scroll;
    padding : calc(100vw*(51/375)) 0 0;
`